"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let WorksheetEditor = class WorksheetEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    getPayload(...args) {
        const [data] = args;
        const fields = this.target && this.targetConfig[this.target].fieldsToSubmit;
        return fields ? _.pick(data, fields) : data;
    }
    worksheet;
    onWorksheet(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("worksheet");
    }
    target;
    onTarget(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("target");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    defaultTitle;
    targetConfig;
    ux;
    dataMembers = ['formId', 'defaultTitle', 'targetConfig', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                defaultTitle: this.$fn.pgettext("Worksheet", "Edit Worksheet"),
                targetConfig: {
                    header: {
                        title: this.$fn.pgettext("Worksheet", "Edit Worksheet Header"),
                        fieldsToSubmit: ["id",
                            "revision_id",
                            "etag",
                            "company",
                        ],
                    },
                },
                ux: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.target ? this.targetConfig[this.target].title : this.defaultTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5734_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_closeComponent_5736_getActionArgs($event) {
        return {
            result: {
                cancel: true,
            },
        };
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_5534025912102772_closeModal_5740_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_5534025912102772_crud_5738_getActionArgs($event) {
        return {
            objectType: "worksheet",
            op: "upsert",
            data: this.getPayload(this.worksheet),
        };
    }
    async evh_5534025912102772_submit(event, scope) {
        return await this.actions.evh_5534025912102772_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeComponent_5742_getActionArgs($event) {
        return {
            result: {
                cancel: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5734 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5734_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5733 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5734,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5733],
        });
        const act_2248226175642056_closeComponent_5736 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_2248226175642056_closeComponent_5736_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_close_5735 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_5736,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5735],
        });
        const act_5534025912102772_closeModal_5740 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_5534025912102772_closeModal_5740_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_success_5739 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_closeModal_5740,
            event: "success",
            displayName: "closeModal",
        });
        const act_5534025912102772_crud_5738 = new core_1.actions.CRUDAction({
            actionArgs: this.act_5534025912102772_crud_5738_getActionArgs,
            displayName: "save",
            events: [evh_5534025912102772_success_5739],
        });
        const evh_5534025912102772_submit_5737 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_crud_5738,
            event: "submit",
            displayName: "save",
        });
        const evh_5534025912102772_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_submit_5737],
        });
        const act_1419464017721962_closeComponent_5742 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1419464017721962_closeComponent_5742_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_5741 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_5742,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_5741],
        });
        return {
            act_7315092382398562_closeModal_5734,
            evh_7315092382398562_close_5733,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_5736,
            evh_2248226175642056_close_5735,
            evh_2248226175642056_close,
            act_5534025912102772_closeModal_5740,
            evh_5534025912102772_success_5739,
            act_5534025912102772_crud_5738,
            evh_5534025912102772_submit_5737,
            evh_5534025912102772_submit,
            act_1419464017721962_closeComponent_5742,
            evh_1419464017721962_clickPreventStop_5741,
            evh_1419464017721962_clickPreventStop,
            save: act_5534025912102772_crud_5738,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], WorksheetEditor.prototype, "worksheet", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('worksheet'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WorksheetEditor.prototype, "onWorksheet", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], WorksheetEditor.prototype, "target", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('target'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WorksheetEditor.prototype, "onTarget", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], WorksheetEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WorksheetEditor.prototype, "onSize", null);
WorksheetEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], WorksheetEditor);
exports.default = WorksheetEditor;
vue_property_decorator_1.Vue.component("WorksheetEditor", WorksheetEditor);
